import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svgs/icons/arrow_botton.svg'


const _withScopeId = n => (_pushScopeId("data-v-261ed3d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-header-card" }, "Campaign", -1))
const _hoisted_2 = {
  style: {"overflow":"auto"},
  class: "container-campaign-table"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  style: {"width":"185px","text-align":"start"},
  class: "wmx-185"
}, " Campaign Name ", -1))
const _hoisted_5 = { class: "filter" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "filter" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  class: "filter",
  style: {"justify-content":"start"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Goal", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "SVG Image"
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Reward", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "link" }, "Link", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "wmx-150",
  style: {"text-align":"start"}
}, "Status", -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["title"]
const _hoisted_19 = { style: {"text-align":"center"} }
const _hoisted_20 = { style: {"text-align":"center"} }
const _hoisted_21 = { style: {"text-align":"start"} }
const _hoisted_22 = { style: {"text-align":"center"} }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { style: {"text-align":"center"} }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 0,
  style: {"text-align":"start"}
}
const _hoisted_28 = {
  key: 0,
  class: "d-flex justify-center"
}
const _hoisted_29 = { class: "d-flex justify-center align-center" }
const _hoisted_30 = {
  key: 1,
  class: "error"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "font-weight-bold",
  style: {"font-size":"1rem"}
}, "Error Found", -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  key: 2,
  class: "no-data"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "font-weight-bold",
  style: {"font-size":"1rem"}
}, "No Data", -1))
const _hoisted_35 = [
  _hoisted_34
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VTab = _resolveComponent("VTab")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_InputCheckBox = _resolveComponent("InputCheckBox")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        class: _normalizeClass(
        _ctx.getWindowsSize['x'] < 600
          ? 'container ma-0 pb-10 pl-2'
          : 'container ma-0 pb-10'
      )
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VTab, {
            data: _ctx.tabCampaign,
            onMenu: _ctx.onChangeTabsActive
          }, null, 8, ["data", "onMenu"])
        ]),
        _: 1
      }, 8, ["class"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", null, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_3,
              _hoisted_4,
              _createElementVNode("th", null, [
                _createElementVNode("div", _hoisted_5, [
                  _createTextVNode(" Start Date "),
                  _createElementVNode("img", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sortStartDate())),
                    src: _ctx.$data[_ctx.sortIconStartDate],
                    alt: "START Date"
                  }, null, 8, _hoisted_6)
                ])
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("div", _hoisted_7, [
                  _createTextVNode(" End Date "),
                  _createElementVNode("img", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sortEndDate())),
                    src: _ctx.$data[_ctx.sortIconEndDate],
                    alt: "END Date"
                  }, null, 8, _hoisted_8)
                ])
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onToggle = !_ctx.onToggle))
                  }, _hoisted_12),
                  _createElementVNode("ul", {
                    class: _normalizeClass([{ show: _ctx.onToggle }, "hidden text-left"])
                  }, [
                    _createVNode(_component_InputCheckBox, {
                      label: 'Payment',
                      "sync-data": _ctx.goal.PAYMENT,
                      selected: true,
                      onChecked: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onChangeGoalFilter(_ctx.goal.PAYMENT, $event))),
                      onUnChecked: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onChangeGoalFilter(_ctx.goal.PAYMENT, $event)))
                    }, null, 8, ["sync-data"]),
                    _createVNode(_component_InputCheckBox, {
                      label: 'Create Merchant',
                      "sync-data": _ctx.goal.CREATE_MERCHANT,
                      selected: true,
                      onChecked: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onChangeGoalFilter(_ctx.goal.CREATE_MERCHANT, $event))),
                      onUnChecked: _cache[6] || (_cache[6] = ($event: any) => (
                      _ctx.onChangeGoalFilter(_ctx.goal.CREATE_MERCHANT, $event)
                    ))
                    }, null, 8, ["sync-data"]),
                    _createVNode(_component_InputCheckBox, {
                      label: 'Register',
                      "sync-data": _ctx.goal.REGISTER,
                      selected: true,
                      onChecked: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onChangeGoalFilter(_ctx.goal.REGISTER, $event))),
                      onUnChecked: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onChangeGoalFilter(_ctx.goal.REGISTER, $event)))
                    }, null, 8, ["sync-data"])
                  ], 2)
                ])
              ]),
              _hoisted_13,
              _hoisted_14,
              _hoisted_15
            ])
          ]),
          (!_ctx.isLoadingCampaigns)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaigns, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: _normalizeClass({ 'line-end': index === _ctx.campaigns.length - 1 })
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.numberHeader(index + 1)), 1)
                    ]),
                    _createElementVNode("td", {
                      style: {"text-align":"start"},
                      onClick: ($event: any) => (_ctx.routingCampaigns(item.campaignCode))
                    }, [
                      _createElementVNode("div", {
                        style: {"min-width":"200px","width":"200px"},
                        class: "ellipsis blue",
                        title: item.nameCampaign
                      }, _toDisplayString(item.nameCampaign), 9, _hoisted_18)
                    ], 8, _hoisted_17),
                    _createElementVNode("td", _hoisted_19, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.onChangeFormatDate(item.startDate)), 1)
                    ]),
                    _createElementVNode("td", _hoisted_20, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.onChangeFormatDate(item.endDate)), 1)
                    ]),
                    _createElementVNode("td", _hoisted_21, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.onChangeFormatGoal(item.action)), 1)
                    ]),
                    _createElementVNode("td", _hoisted_22, [
                      (item.type === 'PERCENT')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(item.amountPercent) + "%", 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(item.amountPerTime) + " THB/Time", 1))
                    ]),
                    _createElementVNode("td", _hoisted_25, [
                      _createElementVNode("a", {
                        href: "",
                        class: "blue",
                        onClick: ($event: any) => (_ctx.onClickLink(item.campaignCode))
                      }, "Link", 8, _hoisted_26)
                    ]),
                    (_ctx.campaignFilter.status === 'All')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_27, [
                          _createElementVNode("p", null, _toDisplayString(item.isActive ? "Active" : "Inactive"), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.isLoadingCampaignTable)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
              _createElementVNode("td", _hoisted_29, [
                _createVNode(_component_v_progress_circular, {
                  class: "mt-5",
                  color: "#3B3C66",
                  indeterminate: "",
                  width: 3,
                  size: 25
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isErrorFoundCampaignTable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
          : _createCommentVNode("", true),
        (_ctx.isNoDataCampaignTable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35))
          : _createCommentVNode("", true),
        _createVNode(_component_Pagination, {
          class: "pt-5",
          justifyContent: _ctx.getWindowsSize['x'] < 600 ? 'center' : 'flex-end',
          data: _ctx.campaignFilter.pagination,
          totalPage: _ctx.pagination.totalPages,
          onPage: _ctx.pageNow,
          onPerPageEvent: _ctx.changeNumberPerPage,
          onLength: _ctx.changeLength
        }, null, 8, ["justifyContent", "data", "totalPage", "onPage", "onPerPageEvent", "onLength"])
      ])
    ]),
    _: 1
  }))
}